import { useApiClient } from '@portals-platform/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CreatedCertificateResponse } from '../api/responses.js';
import { buildCertificatePayload } from '../mappers/certificate-mappers.js';
import type { CertificateInput } from '../models.js';
import { queryKeys } from '../query-keys.js';

export interface CreateCertificateVariables {
  input: CertificateInput;
  captivePolicyId: string;
  isCertificateLive: boolean;
}

export function useCreateCertificate() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation<CreatedCertificateResponse, Error, CreateCertificateVariables>({
    mutationFn: ({ input, captivePolicyId, isCertificateLive }) =>
      client
        .post<CreatedCertificateResponse>(
          ENDPOINTS.certificates,
          buildCertificatePayload(input, captivePolicyId),
          { params: { isCertificateLive } },
        )
        .then((response) => response.data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.certificates() }),
  });
}
